import React from 'react';
import { Download } from 'lucide-react';
const contents = [{
  emoji: '📸',
  label: 'Fotografías de la escena del crimen'
}, {
  emoji: '✉️',
  label: 'Cartas y mensajes entre sospechosos'
}, {
  emoji: '🗂️',
  label: 'Documentos confidenciales y expedientes'
}, {
  emoji: '🔬',
  label: 'Informes de autopsia y análisis forense'
}, {
  emoji: '💰',
  label: 'Recibos bancarios y pruebas financieras'
}, {
  emoji: '⚖️',
  label: 'Registros judiciales y testimonios'
}];
const badges = ['Testimonios', 'Recibos bancarios', 'Autopsias', 'Juicios y pleitos', 'Evidencias', 'Fotografías', 'Informes forenses', 'Cartas secretas'];
export function EvidenceSection() {
  return <section className="py-8 px-4 relative overflow-hidden" style={{
    background: 'linear-gradient(180deg, #6b0000 0%, #3d0000 30%, #1a0000 60%, #000000 100%)'
  }} data-id="element-52">
      {/* Decorative diagonal lines */}
      <div className="absolute inset-0 pointer-events-none opacity-5" style={{
      backgroundImage: 'repeating-linear-gradient(45deg, #c0392b 0, #c0392b 1px, transparent 0, transparent 50%)',
      backgroundSize: '20px 20px'
    }} data-id="element-53" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-54">
        {/* EVIDENCIA REAL stamp */}
        <div className="flex justify-center mb-6" data-id="element-55">
          <div className="px-6 py-2 text-center" style={{
          border: '3px solid #f0c040',
          color: '#f0c040',
          fontFamily: "'Playfair Display', serif",
          fontWeight: 900,
          fontSize: '1.1rem',
          letterSpacing: '0.3em',
          transform: 'rotate(-2deg)',
          textTransform: 'uppercase'
        }} data-id="element-56">
            EVIDENCIA REAL
          </div>
        </div>

        <h2 className="text-center text-2xl sm:text-3xl font-bold text-white mb-3" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-57">
          ¿Qué contienen los expedientes?
        </h2>
        <p className="text-center text-gray-300 text-sm mb-6" data-id="element-58">
          Cada caso es un archivo completo con evidencias reales del crimen
        </p>

        {/* Content list */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6" data-id="element-59">
          {contents.map(item => <div key={item.label} className="flex items-center gap-3 p-3 rounded" style={{
          backgroundColor: 'rgba(0,0,0,0.5)',
          border: '1px solid rgba(192,57,43,0.3)'
        }} data-id="element-60">
              <span className="text-xl flex-shrink-0" data-id="element-61">{item.emoji}</span>
              <span className="text-gray-200 text-sm" data-id="element-62">{item.label}</span>
            </div>)}
        </div>

        {/* Evidence badges */}
        <div className="mb-6" data-id="element-63">
          <p className="text-center text-xs text-gray-500 uppercase tracking-widest mb-4" data-id="element-64">
            Tipos de evidencia incluidos
          </p>
          <div className="flex flex-wrap justify-center gap-2" data-id="element-65">
            {badges.map(badge => <span key={badge} className="px-3 py-1.5 text-xs font-semibold text-gray-300 uppercase tracking-wide" style={{
            border: '1px solid rgba(192,57,43,0.6)',
            backgroundColor: 'rgba(192,57,43,0.1)',
            letterSpacing: '0.08em'
          }} data-id="element-66">
                {badge}
              </span>)}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-67">
          <a href="https://www.resuelvecasos.online/cart/47736555077876:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          ;
          (window as any).fbq?.('track', 'AddToCart');
        }} className="inline-flex items-center gap-3 px-8 py-4 text-base font-black text-white rounded-lg transition-all hover:opacity-90 active:scale-95" style={{
          backgroundColor: '#c0392b',
          boxShadow: '0 0 30px rgba(192,57,43,0.4)',
          letterSpacing: '0.05em'
        }} data-id="element-68">
            <Download size={20} data-id="element-69" />
            RESUELVE CASOS
          </a>
        </div>
      </div>
    </section>;
}